import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationComponent } from 'app/permits/permit-application/shared/confirmation/confirmation.component';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-permit-congratulations',
  templateUrl: './permit-congratulations.component.html',
  styleUrls: ['./permit-congratulations.component.css']
})
export class PermitCongratulationsComponent implements OnInit {
id:any;
isAdmin = false;
  constructor(public utility: UtilityServiceService,private activeRoute: ActivatedRoute,private router: Router) { }

  ngOnInit(): void {
    this.activeRoute.params.subscribe((params: Params) =>{
      this.id = params['id'];
    })
    if (environment.authWebApi.userData.Roles.find(p => p.Code == 'ADMIN')) {
      this.isAdmin = true;
     
    }
      
  }
  landing(){
    this.router.navigate(['/carrier/permit/application/' + this.id]);
  }
  applicationList(){
    this.router.navigate(['/permit/approval']);
  }
  

}
